import { getCustomerFullAddress } from "../../utils";
import { AddressInputWithId } from "./types";
import { Address } from "@core/types";

export const areTwoAddressesSimilar = (unAuthAddress: AddressInputWithId, authAddress: Address) => {
  return (
    authAddress.city === unAuthAddress.city &&
    authAddress.house === unAuthAddress.house &&
    authAddress.state === unAuthAddress.state &&
    authAddress.isFlat === unAuthAddress.isFlat &&
    authAddress.street === unAuthAddress.street &&
    authAddress.floor === (unAuthAddress.floor ?? "") &&
    authAddress.entrance === (unAuthAddress.entrance ?? "") &&
    authAddress.apartmentNumber === (unAuthAddress.apartmentNumber ?? "")
    // authAddress.intercom === (unAuthAddress.intercom ?? "") &&
    // authAddress.latitude === unAuthAddress.latitude &&
    // authAddress.longitude === unAuthAddress.longitude &&
  );
};

export const filterOutSimilarUnAuthAddresses = (
  customerAddresses: Address[],
  unAuthedCustomerAddresses: AddressInputWithId[],
) => {
  return unAuthedCustomerAddresses.filter((unAuthed) => {
    const similarAddress = customerAddresses?.find((authed) => {
      return areTwoAddressesSimilar(unAuthed, authed);
    });

    return !similarAddress;
  });
};

export const convertAddressInputWithIdToAddress = (address: AddressInputWithId): Address => {
  return {
    ...address,
    fullAddress: getCustomerFullAddress({
      city: address.city,
      house: address.house,
      isFlat: address.isFlat,
      street: address.street,
      apartmentNumber: address.apartmentNumber,
    }),
  };
};
